import { c as _c } from "react/compiler-runtime";
import { DigitalTextFieldCell } from "@website/ui/digital-text-field/digital-text-field-cell";
import { useDigitalTextField } from "@website/ui/digital-text-field/digital-text-field.hook";
import styles from "@website/ui/digital-text-field/digital-text-field.module.scss";
import { DigitalTextFieldPropertiesType } from "@website/ui/digital-text-field/digital-text-field.types";
import { FC, JSX, useEffect } from "react";
export const DigitalTextField: FC<DigitalTextFieldPropertiesType> = properties => {
  const $ = _c(17);
  const {
    className,
    error,
    helperText,
    num
  } = properties;
  const {
    inputProps,
    cellsProps,
    inputReference
  } = useDigitalTextField(properties);
  let t0;
  if ($[0] !== inputReference) {
    t0 = () => {
      const timer = setTimeout(() => inputReference.current?.focus?.(), 250);
      return () => clearTimeout(timer);
    };
    $[0] = inputReference;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [];
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  useEffect(t0, t1);
  let cellsList;
  if ($[3] !== cellsProps || $[4] !== num) {
    cellsList = [];
    for (let index = 0; index < num; index++) {
      cellsList.push(<DigitalTextFieldCell key={index} {...cellsProps[index]} />);
    }
    $[3] = cellsProps;
    $[4] = num;
    $[5] = cellsList;
  } else {
    cellsList = $[5];
  }
  const t2 = `${styles["digital-text-field"]} ${error ? styles.error : ""} ${className ?? ""}`;
  let t3;
  if ($[6] !== inputProps) {
    t3 = <input className={styles["digital-text-field-input"]} {...inputProps} />;
    $[6] = inputProps;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== cellsList) {
    t4 = <div className={styles["digital-text-field-box"]}>{cellsList}</div>;
    $[8] = cellsList;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== helperText) {
    t5 = helperText ? <div className={styles["digital-text-field-helper-text"]}>{helperText}</div> : null;
    $[10] = helperText;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t2 || $[13] !== t3 || $[14] !== t4 || $[15] !== t5) {
    t6 = <div className={t2}>{t3}{t4}{t5}</div>;
    $[12] = t2;
    $[13] = t3;
    $[14] = t4;
    $[15] = t5;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  return t6;
};